import { Navigate, useParams } from 'react-router';
import { useRoute } from 'src/router/hooks/useRoute';
import { useWithdrawalRedirect } from './hooks/useWithdrawalRedirect';
import {
  getTransactionType,
  TRANSACTION_TYPE_DEPOSIT,
  TRANSACTION_TYPE_WITHDRAWAL
} from 'src/utils/transactionTypeFromLS';
import { TransactionStatus } from './types';
import { useDepositRedirect } from './hooks/useDepositRedirect';
import { useRef } from 'react';

export function DepositReturn({ status }: { status: TransactionStatus }) {
  const { merchantId } = useParams<{ merchantId: string }>();
  const prevPath = localStorage.getItem('prevPathDeposit');
  const { ROUTE } = useRoute();
  const operationType = getTransactionType();
  const initialOperationRef = useRef(operationType);
  const isInitialWithdrawal = initialOperationRef.current === TRANSACTION_TYPE_WITHDRAWAL;
  const isDepositType = operationType === TRANSACTION_TYPE_DEPOSIT;

  useWithdrawalRedirect({ status, isInitialWithdrawal });

  useDepositRedirect({ status, operationType, isDepositType, merchantId });

  if (isInitialWithdrawal) {
    return <Navigate to={ROUTE.ACCOUNT_WALLET_HISTORY.get()} />;
  }

  return (
    <Navigate
      to={`${prevPath ? prevPath : ROUTE.ACCOUNT_DEPOSIT_HISTORY.get()}`}
      state={{ merchantId }}
    />
  );
}
